export default __webpack_public_path__ + "static/media/lightning-fill.cda871ee.svg";